// swatch-label.js
//
// Hovering a colour reads its name out in that group's own label row. Each
// swatch type -- colour, prints, textured prints, seasonal -- is its own group
// with its own readout, so a print name never lands under the "Colour" label
// and a product whose group has no colours still gets a readout (OB-245).
(() => {
  const WRAP_SELECTOR = ".x-swatch-wrap";
  const GROUP_SELECTOR = "[data-swatch-group]";
  const SECTION_SELECTOR = ".x-swatch-section";
  const INIT_ATTR = "data-swatch-init";

  function initGroup(group) {
    if (!group || group.hasAttribute(INIT_ATTR)) return;

    const scope = group.closest(SECTION_SELECTOR) || group.closest(WRAP_SELECTOR);
    const label = scope && scope.querySelector("[data-swatch-label]");
    if (!label) return;

    group.setAttribute(INIT_ATTR, "1");

    const defaultName = group.getAttribute("data-default-name") || "";
    const setLabel = (name) => (label.textContent = name || defaultName);

    // initial text
    setLabel(defaultName);

    const swatches = group.querySelectorAll(".x-swatch[data-swatch-name]");
    swatches.forEach((a) => {
      const name = a.getAttribute("data-swatch-name") || "";

      a.addEventListener("mouseenter", () => setLabel(name));
      a.addEventListener("focus", () => setLabel(name));

      a.addEventListener("mouseleave", () => setLabel(defaultName));
      a.addEventListener("blur", () => setLabel(defaultName));
    });
  }

  function initWrap(wrap) {
    if (!wrap) return;
    wrap.querySelectorAll(GROUP_SELECTOR).forEach(initGroup);
  }

  function initAll(root = document) {
    root.querySelectorAll(WRAP_SELECTOR).forEach(initWrap);
  }

  function boot() {
    initAll();

    // Watch for product cards being injected (load more, filters, quick view, etc.)
    const obs = new MutationObserver((mutations) => {
      for (const m of mutations) {
        for (const node of m.addedNodes) {
          if (!(node instanceof HTMLElement)) continue;

          if (node.matches?.(WRAP_SELECTOR)) initWrap(node);
          node.querySelectorAll?.(WRAP_SELECTOR).forEach(initWrap);
        }
      }
    });

    obs.observe(document.documentElement, { childList: true, subtree: true });

    // Also catch Shopify section reloads
    document.addEventListener("shopify:section:load", (e) => initAll(e.target));
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();
